import React, { forwardRef } from "react";
import classes from "./index.module.css";
import smallClasses from "./smallButton.module.css";
import Text from "@/components/Text";
import { Button } from "@mantine/core";
import { ButtonProps } from "@mantine/core";
import { RadioCheckboxTick } from "@/components/Icons";

interface RadioButtonProps extends ButtonProps {
  title: React.ReactNode;
  label?: string;
  icon?: React.ReactNode;
  active?: boolean;
  disabled?: boolean;
  small?: boolean;
  onClick: () => void;
}

const RadioButton = forwardRef<HTMLButtonElement, RadioButtonProps>((props, ref) => {
  const { icon, active, disabled, title, label, small = false, ...rest } = props;
  const showIcon = icon ?? (small && <RadioCheckboxTick data-testid="tickCz" fontSize={18} />);

  return (
    <Button
      ref={ref}
      size={small ? "sm" : "md"}
      classNames={small ? smallClasses : classes}
      leftSection={showIcon}
      disabled={disabled}
      data-active={active}
      justify="flex-start"
      {...rest}>
      <Text variant={small ? "reading_medium" : "subheadline_bold"} span color="inherit">
        {title}
      </Text>
      {label && (
        <Text variant="reading" color="inherit">
          {label}
        </Text>
      )}
    </Button>
  );
});

export default RadioButton;
